var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"treasury-kids"},[_c('div',{staticClass:"treasury-kids-container"},[_c('treasury-kids-form',{attrs:{"display-names":_vm.displayNames,"date":_vm.date},on:{"date-change":_vm.getFiles}}),_c('treasury-kids-result',{attrs:{"files":_vm.filteredFiles}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }